import { Divider, Button } from "@oxygen/core";
import { Notification } from "@oxygen/icons";
import getThemeClasses from "@oxygen/theme";
import { openSubscriptionPopup } from "GlobalActionCreator/SubscriptionPopup";
import { CSSFlex } from "GlobalComponent/CSSCore/CSSFlex";
import { SUBSCRIPTION_EVENT } from "GlobalConstant/";
import { showNotificationPermission } from "GlobalUtils/Notifications";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import styles from "./scss/SubscribeLink.module.scss";
import { storage } from "GlobalUtils/Storage";
import { platform } from "GlobalEnum/Platform";

const propTypes = {
  showNotifyMe: PropTypes.bool,
  modelId: PropTypes.number,
};

const defaultProps = {
  modelId: -1,
  showNotifyMe: false,
};

const subscribeTextClasses = getThemeClasses(`
  ml-2;
  color-blue-light;
  font-size-7.5 md:font-size-8;
`);

const subscribeClasses = getThemeClasses(`
  mt-3;
  color-blue-light;
  align-items-center;
  cursor-pointer;
`);
const subSubscribeButtonTextClasses = getThemeClasses(`
  ml-2;
  font-size-7.5 md:font-size-8;
`);
const buttonClasses = getThemeClasses(`
  mt-5;
`);
function SubscribeLink(props) {
  const {
    showNotifyMe,
    modelId,
    isButtonDesign,
    platForm = platform.MOBILE,
    makeName,
    modelName,
  } = props;

  const [showSubscribeToNewsletter, setShowSubscribeToNewsletter] = useState(
    false
  );
  const checkNotifcationStatus = () => {
    let isNotificationClosed = storage.getSessionValue(
      "cwc__notificationClosed"
    );
    if (
      isNotificationClosed === 1 ||
      (window &&
        window.Notification &&
        window.Notification.permission !== "default")
    ) {
      setShowSubscribeToNewsletter(true);
    }
  };
  const dispatch = useDispatch();
  useEffect(() => {
    checkNotifcationStatus();
    //binding onchange event
    document.addEventListener(SUBSCRIPTION_EVENT.name, checkNotifcationStatus);
    return () => {
      document.removeEventListener(
        SUBSCRIPTION_EVENT.name,
        checkNotifcationStatus
      );
    };
  }, []);
  const handleSubscribeLinkClick = () => {
    showSubscribeToNewsletter
      ? dispatch(openSubscriptionPopup(modelId, makeName, modelName))
      : showNotificationPermission(true);
  };
  const subscribeText = showSubscribeToNewsletter
    ? "Alert Me When Launched"
    : "Notify me";
  if (!showNotifyMe) {
    return null;
  }
  return isButtonDesign ? (
    <Button
      color="secondary"
      variant="ghost"
      size="md"
      block={platForm.id === platform.MOBILE.id}
      data-testing-id="subscription-link-button-design"
      className={buttonClasses}
      onClick={handleSubscribeLinkClick}
    >
      <Notification size="sm" />
      <span className={subSubscribeButtonTextClasses}>
        {`Alert Me When Launched`}
      </span>
    </Button>
  ) : (
    <div
      className={styles.container}
      onClick={handleSubscribeLinkClick}
      data-testing-id="subscription-link-text-design"
    >
      <Divider />
      <CSSFlex className={subscribeClasses}>
        <Notification size="sm" />
        <p className={subscribeTextClasses}>{subscribeText}</p>
      </CSSFlex>
    </div>
  );
}

SubscribeLink.propTypes = propTypes;
SubscribeLink.defaultProps = defaultProps;

export default SubscribeLink;
